import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { MoonLoader } from 'react-spinners'
import Modal from 'src/components/ui/Modal'
import { rechargeWallet } from 'src/state/actions/riders'
import { IStoreState, IWalletTransactionResponseDTO } from 'src/types'
import UIMessages from 'src/utils/ui-messages'

const RechargeWalletButton: React.FC<IWalletTransactionResponseDTO> = props => {
  const [showModal, setShowModal] = useState(false)
  const [otp, setOTP] = useState('')
  const isProcessing = useSelector((state: IStoreState) => {
    return state.riders.metadata.processing
  })
  const dispatch = useDispatch()

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setOTP('')
  }

  const handleOTPChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOTP(event.target.value)
  }

  const handleVerifyOTP = () => {
    // TODO: Implement API call to verify OTP, static for now
    if (otp === '123456') {
      // THIS IS STATIC FOR NOW
      dispatch(rechargeWallet(props.id))
    }
  }

  return (
    <div className='col-2'>
      <button onClick={handleOpenModal}>Recharge</button>
      {showModal && (
        <Modal>
          <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
            <div className='bg-white col-4 p2'>
              {isProcessing ? (
                <>
                  <div className='flex justify-center'>
                    <MoonLoader sizeUnit={'px'} size={50} color={'#405264'} loading={true} />
                  </div>
                  <div className='flex justify-center'>
                    <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 h3'>Processing request ... </span>
                  </div>
                </>
              ) : (
                <>
                  <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 h3'>OTP Verification</span>
                  <div className='m1'>
                    <input
                      id='otpInput'
                      type='text'
                      className='p1 fit ml1'
                      placeholder='Enter OTP'
                      value={otp}
                      onChange={handleOTPChange}
                    />
                  </div>
                  <button onClick={handleCloseModal} className='CancelButton btn bg-white rounded font-light-grey mr2'>
                    {UIMessages.common.cancel}
                  </button>
                  <button onClick={handleVerifyOTP} className='SubmitButton btn bg-green rounded font-white weight-300'>
                    Verify OTP
                  </button>
                </>
              )}
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}

export default RechargeWalletButton



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/RechargeWalletButton.tsx